import { useSolvePoller } from "store/functions/useSolvePoller.js";

/**
 * Renders nothing — it exists solely to host the solve poller's Redux
 * subscription in a leaf of the tree.
 *
 * The poller subscribes to `solveJobs`, which updates as runs are polled. If the
 * hook were called directly in a layout component, every poll would re-render the
 * whole layout subtree — including the (expensive) map. Isolating it here means a
 * poll only re-renders this empty component, not the map.
 */
export default function SolvePoller() {
  useSolvePoller();
  return null;
}
